(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["countdown-timer"] && !Shopify.designMode) return;
  try {
    (function () {
    const el = document.querySelector('[data-deal-countdown]');
    if (!el) return;

    const daysEl = el.querySelector('[data-countdown-days]');
    const hoursEl = el.querySelector('[data-countdown-hours]');
    const minsEl = el.querySelector('[data-countdown-mins]');
    const secsEl = el.querySelector('[data-countdown-secs]');

    function getTarget() {
      const now = new Date();
      const day = now.getUTCDay();
      const h = now.getUTCHours();
      const m = now.getUTCMinutes();
      let daysUntil = (1 - day + 7) % 7;
      if (daysUntil === 0 && (h > 7 || (h === 7 && m > 0))) daysUntil = 7;
      const t = new Date(now);
      t.setUTCDate(now.getUTCDate() + daysUntil);
      t.setUTCHours(7, 0, 0, 0);
      return t;
    }

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      let diff = Math.max(0, Math.floor((getTarget() - Date.now()) / 1000));
      const d = Math.floor(diff / 86400); diff -= d * 86400;
      const h = Math.floor(diff / 3600); diff -= h * 3600;
      const min = Math.floor(diff / 60);
      const s = diff - min * 60;
      daysEl.textContent = d;
      hoursEl.textContent = pad(h);
      minsEl.textContent = pad(min);
      secsEl.textContent = pad(s);
      if (d === 0 && h < 2) el.setAttribute('data-urgent', '');
      else el.removeAttribute('data-urgent');
    }

    tick();
    setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
